import React, { useState } from 'react';
import { observer } from 'mobx-react';
// import Button from 'components/Button';
import PropTypes from 'prop-types';

import {
  Menu,
  MenuButton,
  Flex,
  Button as ChakraButton,
  MenuItem,
  Collapse,
  Checkbox,
  MenuDivider,
  MenuList,
} from '@chakra-ui/react';

import { SvgIcon, Box } from 'components';
import { Filter } from 'icons';
import {
  ErrorHandler,
  ErrorRecoveryMessage,
} from 'libs/rendering/components/errorHandler';
import { action } from 'mobx';

export { DateFilter } from './filter/date';
export { EnumFilter } from './filter/enum';
export { SpaceFilter } from './filter/space';

const FilterFieldView = observer(({ filter }) => {
  const { selected, ToggleSelect } = filter.filterField;
  const FilterView = filter.constructor.View;
  return (
    <React.Fragment>
      <MenuDivider my={0} />
      <MenuItem py={3} px={2} _hover={{ backgroundColor: 'white' }}>
        <Checkbox
          colorScheme='blue'
          isChecked={selected}
          onChange={ToggleSelect}
          color='black'
        >
          {filter.filterField.title}
        </Checkbox>
      </MenuItem>
      <Collapse in={selected} animateOpacity>
        <MenuDivider my={0} />
        <FilterView filter={filter} />
      </Collapse>
    </React.Fragment>
  );
});

const FilterIconButton = ({ onClick, filterNumbers }) => {
  return (
    <MenuButton
      onClick={onClick}
      border='1px solid'
      borderColor='blue'
      borderRadius='20px'
      p='0.5rem 0.5rem'
      h='32px'
      fontSize='sm'
      minWidth='1rem'
      color='blue'
      cursor='pointer'
      _hover={{
        borderColor: 'blue',
        backgroundColor: 'blue.50',
      }}
      size='sm'
    >
      <SvgIcon size='medium' icon={<Filter />} color='primary' />
      {filterNumbers !== 0 && filterNumbers}
    </MenuButton>
  );
};

FilterIconButton.propTypes = {
  onClick: PropTypes.func,
  filterNumbers: PropTypes.number,
};

const FilterError = observer(({ conn, errorState }) => {
  const [open, setOpen] = useState(false);

  const handleFilterBtnClick = () => {
    setOpen(prevState => !prevState);
  };

  const tryRecover = () => {
    action(() => {
      conn.ClearFilters();
      conn.ApplyFilters(setOpen);
      errorState.ClearError();
    })();
  };

  return (
    <Menu
      closeOnSelect={false}
      closeOnBlur={true}
      autoSelect={false}
      onClose={() => {
        conn.ApplyFilters(setOpen);
      }}
      isOpen={open}
    >
      <FilterIconButton
        filterNumbers={conn.localFilters.length}
        onClick={handleFilterBtnClick}
      />
      <MenuList
        minWidth='300px'
        borderRadius='0px'
        borderColor='gray.200'
        boxShadow='lg'
        p={0}
      >
        <Box p={2} sx={{ display: 'flex', alignItems: 'center' }}>
          <ErrorRecoveryMessage
            typeName='Filters'
            tryRecover={tryRecover}
            errorState={errorState}
          />
        </Box>
      </MenuList>
    </Menu>
  );
});

export const FilterByAction = observer(props => {
  return (
    <ErrorHandler ErrorComponent={FilterError} {...props}>
      <FilterByActionInner {...props} />
    </ErrorHandler>
  );
});

const FilterByActionInner = observer(({ conn }) => {
  const [open, setOpen] = useState(false);

  const handleFilterBtnClick = () => {
    setOpen(prevState => !prevState);
  };

  return (
    <Menu
      closeOnSelect={false}
      closeOnBlur={true}
      autoSelect={false}
      onClose={() => {
        conn.ApplyFilters(setOpen);
      }}
      isOpen={open}
    >
      <FilterIconButton
        filterNumbers={conn.localFilters.length}
        onClick={handleFilterBtnClick}
      />
      <MenuList
        minWidth='300px'
        borderRadius='0px'
        borderColor='gray.200'
        boxShadow='lg'
        pb={0}
      >
        <Flex
          flexDirection='row'
          justify='space-between'
          alignItems='center'
          px={2}
          pb={2}
          color='black'
        >
          <ChakraButton
            p='0.643em 0.643em'
            m='0'
            minWidth='5em'
            variant='ghost'
            size='sm'
            borderRadius='20px'
            backgroundColor='gray.100'
            color='black'
            cursor='pointer'
            _hover={{
              borderColor: 'blue',
              backgroundColor: 'gray.200',
            }}
            fontWeight='light'
            onClick={() => conn.ClearFilters()}
          >
            Clear
          </ChakraButton>
          <strong>Filters</strong>
          <ChakraButton
            p='0.643em 0.643em'
            m='0'
            minWidth='5em'
            variant='ghost'
            size='sm'
            borderRadius='20px'
            backgroundColor='blue.50'
            color='blue'
            cursor='pointer'
            _hover={{
              borderColor: 'blue',
              backgroundColor: 'blue.100',
              color: 'blue',
            }}
            fontWeight='light'
            onClick={() => {
              conn.ApplyFilters(setOpen);
            }}
          >
            Apply
          </ChakraButton>
        </Flex>
        {Object.values(conn.filters).map((filter, i) => (
          <FilterFieldView key={i} filter={filter} />
        ))}
      </MenuList>
    </Menu>
  );
});
